import type { FeedEntry, UIComponent } from '~/services/layout';
import { usePreferenceEditor } from './use-preference-editor';
import { useSelectedState } from './use-selected-state';

export function usePreferenceSelector(
  entry: FeedEntry,
  uiComponent: UIComponent
): {
  isPreferenceSelectorCellAndUnselected: boolean;
  isPreferenceSelectorCellAndSelected: boolean;
  preferenceSelectorActionFunction: Function;
} {
  const {
    isSelectedStateCell,
    isSelectedStateCellAndUnselected,
    isSelectedStateCellAndSelected,
    selectedStateActionFunction,
  } = useSelectedState(entry);

  const {
    isPreferenceEditor,
    isBehaviorMultiActionFeedEntry,
    isPreferenceEditorCellAndUnselected,
    isPreferenceEditorCellAndSelected,
    preferenceEditorActionFunction,
  } = usePreferenceEditor(entry, uiComponent);

  let preferenceSelectorActionFunction: Function = () => {};
  let isPreferenceSelectorCellAndUnselected: boolean = false;
  let isPreferenceSelectorCellAndSelected: boolean = false;

  if (isSelectedStateCell) {
    isPreferenceSelectorCellAndUnselected = isSelectedStateCellAndUnselected;
    isPreferenceSelectorCellAndSelected = isSelectedStateCellAndSelected;
    preferenceSelectorActionFunction = selectedStateActionFunction;
  }

  if (isPreferenceEditor || isBehaviorMultiActionFeedEntry) {
    isPreferenceSelectorCellAndUnselected = isPreferenceEditorCellAndUnselected;
    isPreferenceSelectorCellAndSelected = isPreferenceEditorCellAndSelected;
    preferenceSelectorActionFunction = preferenceEditorActionFunction;
  }

  return {
    isPreferenceSelectorCellAndUnselected,
    isPreferenceSelectorCellAndSelected,
    preferenceSelectorActionFunction,
  };
}
